export const MONTH_BUTTON = {
  this: 'this',
  next: 'next',
}

export const THIS_MONTH_MANAGER_TEXTS = {
  acceptBadgeText: 'badge.changeThisMonth',
  acceptBadgeTooltipText: 'workTimeControl.acceptedForThisMonth.tooltipManager',
  acceptDrawerCommentText: 'workTimeControl.acceptThisMonth.body',
  acceptButtonLabel: 'workTimeControl.buttons.acceptThisMonth',
  acceptButtonTestId: 'monthly-sheet-accept-this-month',
} as const

export const NEXT_MONTH_MANAGER_TEXTS = {
  acceptBadgeText: 'badge.changeNextMonth',
  acceptBadgeTooltipText: 'workTimeControl.acceptedForNextMonth.tooltipManager',
  acceptDrawerCommentText: 'workTimeControl.acceptNextMonth.body',
  acceptButtonLabel: 'workTimeControl.buttons.acceptNextMonth',
  acceptButtonTestId: 'monthly-sheet-accept-next-month',
} as const
